import { ComponentProps } from "react";

import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";

/* Sprite-backed: verified-seller badge on every product card: up to 36 per page, 22 KB inline; the path lives in `IconSprite`. */
export const IconStateVerifiedOutlined = (props: ComponentProps<"svg">) => (
  <SpriteIcon
    symbol={SPRITE_SYMBOLS.verifiedOutlined}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  />
);
